import { AudioControllerBehavior, ButtonController, SlotConstantsBehavior, SlotEventConstantsBehavior, SoundConstant, View } from "@quest/murka-games-behavior-panther/dist";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { BaseCoreConstants, ButtonBase, dispatcher, EventConstants, ingenuity, Loading } from "@quest/base-core";
import { SlotConstants, SlotEventConstants } from "@quest/slot-core";

/**
 * ButtonControllerGame class handles the  console panelo of the base game and its buttons.
 */
export class ButtonControllerGame extends ButtonController {

  protected initializeButtons(view: View): void {
    super.initializeButtons(view);
    this.view.getButtonById("CollectionScreenBtn").on(ButtonBase.UP, this.onCollectionPressDown, this);
  }

  /**
   * Override to update Jackpot Meter Value
   */

  protected onChangeStake(value: number): void {
    super.onChangeStake(value);
    dispatcher.fireEvent(eventDispatchers.UPDATE_JACKPOT_METER_VALUE);
    dispatcher.fireEvent(eventDispatchers.RESET_PROGRESS_BAR_IN_BASEGAME);
  }
  /**
   * overrided to reset progress bar
   */
  protected suspendWinWhenButtonPressed(): void {
    super.suspendWinWhenButtonPressed();
    dispatcher.fireEvent(eventDispatchers.RESET_PROGRESS_BAR_IN_BASEGAME);
  }
  /**
   * opens collection panel on button click
   */
  protected onCollectionPressDown(): void {
    (ingenuity.soundManager as AudioControllerBehavior).playSound(SoundConstant.COMMON_CLICK_SOUND, 1, false, SlotConstantsBehavior.SOUND_LIST_PRELOAD);
    if (Loading.isStateLoaded(BaseCoreConstants.loader.STAGE_BASE_GAME_POSTLOAD)) {
      dispatcher.fireEvent(eventDispatchers.INITIALIZE_COLLECTION_SCREEN);
      dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_POST_LOADER);
      dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_BASE_GAME_DURING_BIGWIN);
      dispatcher.fireEvent(eventDispatchers.UPDATE_COLLECTION_PAYOUT);
      dispatcher.fireEvent(eventDispatchers.SHOW_COLLECTION_SCREEN);
      dispatcher.fireEvent(SlotEventConstants.DISABLED_ALL_BUTTONS);
    } else {
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_POST_LOADER);
      dispatcher.on(
        EventConstants.BASEGAME_POSTLOAD_ASSETS_LOADED,
        (e) => {
          this.onCollectionPressDown();
        },
        this,
        true
      );
    }
  }
  protected onSpinStopPressUp() {
    dispatcher.fireEvent(EventConstants.BUTTON_RELESED, SlotConstants.SpinStopBtnId);
    if (this.spinStopBtn?.visible){
      !ingenuity.configData.endReqSent && dispatcher.fireEvent(SlotEventConstants.DISABLED_ALL_BUTTONS);
      this.spinBtn.visible = true;
      this.spinStopBtn.visible = false;
      if (this.model.getIsAutoPlayLeft()) {
        dispatcher.fireEvent(SlotEventConstants.ENABLE_BUTTON, [SlotConstantsBehavior.AutoPlayOffBtnId]);
      }
    }
    dispatcher.fireEvent(SlotEventConstantsBehavior.ON_SPIN_STOP_CLICKED);
  }
}
